import { render, staticRenderFns } from "./fundSubscription.vue?vue&type=template&id=1c20c4ba&scoped=true"
import script from "./fundSubscription.vue?vue&type=script&lang=js"
export * from "./fundSubscription.vue?vue&type=script&lang=js"
import style0 from "./fundSubscription.vue?vue&type=style&index=0&id=1c20c4ba&prod&lang=scss&scoped=true"
import style1 from "./fundSubscription.vue?vue&type=style&index=1&id=1c20c4ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c20c4ba",
  null
  
)

export default component.exports